import { useEffect, useState } from 'react';
import { api, LeaderEntry } from '../api/rest';

export function Leaderboard() {
  const [entries, setEntries] = useState<LeaderEntry[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .leaderboard()
      .then(setEntries)
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="stack">
      <h1>🏆 All-time leaderboard</h1>
      {error && <div className="banner error">{error}</div>}
      {loading ? (
        <p className="muted">Loading…</p>
      ) : entries.length === 0 ? (
        <p className="muted">No games have finished yet.</p>
      ) : (
        <div className="card">
          <ol className="leaderboard">
            {entries.map((e, i) => (
              <li key={e.nickname + i}>
                <span className="rank">{i + 1}</span>
                <span className="lname">{e.nickname}</span>
                <span className="lgames muted small">{e.games} game{e.games === 1 ? '' : 's'}</span>
                <span className="points">{e.totalScore}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}
